import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface SensorData {
  timestamp: number;
  device_id: string;
  metric: string;
  value: number;
}

interface RealTimeChartProps {
  data: SensorData[];
}

const RealTimeChart: React.FC<RealTimeChartProps> = ({ data }) => {
  // Process data for chart
  const chartData = data
    .filter(d => d.metric === 'temperature')
    .slice(-20)
    .map(d => ({
      time: new Date(d.timestamp).toLocaleTimeString(),
      temperature: d.value,
      timestamp: d.timestamp
    }));

  return (
    <div className="h-64">
      <h3 className="text-white font-semibold mb-4">Temperature Trend</h3>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis 
            dataKey="time" 
            stroke="#a855f7"
            fontSize={12}
          />
          <YAxis 
            stroke="#a855f7"
            fontSize={12}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'rgba(0,0,0,0.8)', 
              border: 'none', 
              borderRadius: '8px',
              color: 'white'
            }} 
          />
          <Line 
            type="monotone" 
            dataKey="temperature" 
            stroke="#ef4444" 
            strokeWidth={2}
            dot={{ fill: '#ef4444', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, stroke: '#ef4444', strokeWidth: 2 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RealTimeChart;